<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              library_books
            </v-icon>
            <span class="title">Data Jenis Pekerjaan</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Jenis Pekerjaan
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="4">
                        <v-select
                          :items="liststatus"
                          name="statuskerja"
                          v-model="filter.status"
                          label="Status"
                          @change="getJeniskerja">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editJeniskerja(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddjeniskerja"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                class="text-uppercase-input"
                                v-model="addjeniskerja.nama_kerja"
                                :rules="[rules.required]"
                                label="Nama"
                                name="nama"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="addjeniskerja.deskripsi_kerja"
                                auto-grow
                                label="Deskripsi jenis pekerjaan"
                                rows="1">
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <div class="text-center" v-if="loading.addjenis">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                              <v-btn
                                v-if="!loading.addjenis"
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.jeniskerja"
      max-width="600px"
      v-if="dmodaldata.jeniskerja">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejeniskerja"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        class="text-uppercase-input"
                        v-model="dmodaldata.jeniskerja.nama_kerja"
                        :rules="[rules.required]"
                        label="Nama"
                        name="nama"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.jeniskerja.deskripsi_kerja"
                        auto-grow
                        label="Deskripsi jenis pekerjaan"
                        rows="1">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statuskerja"
                        v-model="dmodaldata.jeniskerja.status_kerja"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <div class="text-center" v-if="loading.editjenis">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </div>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('jeniskerja')">
                        Cancel
                      </v-btn>
                      <v-btn
                        v-if="!loading.editjenis"
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'JeniskerjaAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      addjenis: false,
      editjenis: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
      status: 'active',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJeniskerja();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJeniskerja() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
                status: this.filter.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjeniskerja.validate()) {
        if (this.tokenscr) {
          this.loading.addjenis = true;
          this.axios
            .post(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.addjeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjeniskerja.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'pekerjaan "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJeniskerja();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addjenis = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addjenis = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.alertupdate.show = false;
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.loading.editjenis = true;
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editjenis = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editjenis = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
